/**
 * Common JS.
 *
 * @type {Object}
 *
 * @package Zola-Electric
 */

import '../vendor/sticky-kit';
import '../vendor/lity';
import '../vendor/jquery.sidr';
import '../vendor/jquery.scrollify';
import fancybox from '@fancyapps/fancybox';

const common = {

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {

		this.stickyHeader();
		this.mobileNav();
		this.bannerArrow();
		this.lityClasses();
		this.headerSearch();
		this.thickboxGallery();
		this.homeScrollify();
		this.homeVideoScripts();
	},

	/**
	 * New Home page scroll animation.
	 *
	 * @return {void}
	 */
	homeScrollify: function() {
		if ( $( '.new-home-sections' ).length ) {
			const windowWidth = $( window ).width();

			if ( 767 >= windowWidth ) {
				return false;
			}

			let topPosition = 72;

			if ( $( 'body' ).hasClass( 'admin-bar' ) ) {

				if ( 783 < windowWidth ) {
					topPosition = topPosition + 32;
				} else if ( 782 >= windowWidth && 768 <= windowWidth ) {
					topPosition = topPosition + 46;
				}

			}

			// Spacer to fix offset issue.
			$( '.site-footer' ).append( '<div style="height:' + topPosition + 'px;"></div>' );

			// jQuery Scrollify.
			$.scrollify(
				{
					section: '.new-home-sections',
					updateHash: false,
					interstitialSection: '.site-header, .site-footer',
					offset: -topPosition,
					before: function( i, panels ) {
						$( '.new-home-sections' ).removeClass( 'active-section' );

						// Pagination.
						let ref = panels[i].attr( 'data-section-name' );
						$( '.hmpagination .active' ).removeClass( 'active' );
						$( '.hmpagination' ).find( 'a[href="#' + ref + '"]' ).addClass( 'active' );
					},
					after: function() {
						let current = $.scrollify.current();
						current.addClass( 'active-section' );
					},
					afterRender: function() {
						let pagination  = '<ul class="hmpagination">';
						let activeClass = '';

						$( '.new-home-sections' ).each(
							function( i ) {
								activeClass = '';

								if ( i === $.scrollify.currentIndex() ) {
									activeClass = 'active';
								}

								let pagi_title = $( this ).attr( 'data-section-name' );

								pagi_title = pagi_title.replace( '-', ' ' );

								pagination += '<li><a class="' + activeClass + '" href="#' + $( this ).attr( 'data-section-name' ) + '"><span class="hover-text">' + pagi_title + '</span></a></li>';
							}
						);

						pagination += '</ul>';

						$( '.site-main' ).append( pagination );
						$( '.hmpagination a' ).on( 'click', $.scrollify.move );
					}
				}
			);

			$( '.scrollify-next' ).on(
				'click',
				function( event ) {
					event.preventDefault();

					$.scrollify.next();
				}
			);

		}
	},

	/**
	 * Trigger fancybox for Video URL.
	 *
	 * @return {void}
	 */
	homeVideoScripts: function() {
		const sections = $( '.new-home-sections' );

		if ( ! sections.length ) {
			return;
		}

		const youtubeRegex = /(youtube(-nocookie)?\.com|youtu\.be)\/(watch\?v=|v\/|u\/|embed\/?)?([\w-]{11})(.*)?/i;
		const vimeoRegex   = /(vimeo(pro)?.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/;

		sections.each(
			function() {
				let opener = $( this ).find( '.banner-cta' );
				let target = opener.attr( 'href' );

				let youTubeVideo = youtubeRegex.exec( target );
				let vimeoVideo   = vimeoRegex.exec( target );

				if ( youTubeVideo ) {

					opener.attr( 'data-fancybox', 'true' );

				} else if ( vimeoVideo ) {

					opener.attr( 'data-fancybox', 'true' );

				}
			}
		);
	},

	/**
	 * Header Search.
	 *
	 * @return {void}
	 */
	headerSearch: function() {
		$( '#header-search' ).on( {
			focus: function () {
				$( '#adminbarsearch' ).addClass( 'adminbar-focused' );
			},
			blur: function () {
				$( '#adminbarsearch' ).removeClass( 'adminbar-focused' );
			}
		} );
	},

	stickyHeader: function() {
		const stickyParent = $( '#page' );
		const stickyChild  = $( '#header-wrapper' );
		const windowWidth  = $( window ).width();

		let topPosition = 0;

		if ( $( 'body' ).hasClass( 'admin-bar' ) ) {

			if ( 783 < windowWidth ) {

				topPosition = topPosition + 32;
			} else if ( 782 >= windowWidth && 768 <= windowWidth ) {
				topPosition = topPosition + 46;
			} else {
				topPosition = 0;
			}

		}

		stickyChild.stick_in_parent( {
			'parent': stickyParent,
			'offset_top': topPosition,
			'sticky_class': 'is-stuck'
		} );
	},

	/**
	 * Check if touch device.
	 *
	 * @return {boolean}
	 */
	isTouchDevice: function() {
		return ! ! ( 'ontouchstart' in window );
	},

	/**
	 * Mobile nav
	 *
	 * @return {void}
	 */
	mobileNav: function() {
		const $mobileNav = $( '#mobile-nav' );

		if ( ! $mobileNav.length ) {
			return;
		}

		$mobileNav.sidr( {
			displace: false,
			name: 'sidr-right',
			side: 'right',
			source: '#main-navigation',
			speed: 200,
			onOpen: function() {
				$( 'html, body' ).addClass( 'prevent-scroll' );
				$mobileNav.children( 'i' ).removeClass( 'icon-menu' ).addClass( 'icon-cancel' );

				// Add event when menu is open.
				setTimeout( () => {
					$( document ).on( 'click.sidrMenu', documentClick );
				}, 1 );

				let $els = $( '.sidr-class-menu-item-has-children' );
				let $a;

				$els.each( function() {
					$a = $( this );

					if ( ! $a.find( 'span' ).length ) {
						$a.prepend( '<span class=\'icon-up-dir\'></span>' );
					}
				} );

			},
			onClose: function() {
				$( 'html, body' ).removeClass( 'prevent-scroll' );
				$mobileNav.children( 'i' ).removeClass( 'icon-cancel' ).addClass( 'icon-menu' );
			}
		} );

		// Close sidr menu on document click.
		const documentClick = function( event ) {

			const container = $( '#sidr-right' );

			if ( ! container.is( event.target ) && 0 === container.has( event.target ).length ) {

				$.sidr( 'close', 'sidr-right' );

				$( document ).off( 'click.sidrMenu' );

			}

		};

		// Hide sidr menu on click on close icon.
		$( '.sidr-class-close' ).on( 'click touchstart', function( event ) {

			event.preventDefault();
			$.sidr( 'close', 'sidr-right' );
			$( document ).off( 'click.sidrMenu' );

		} );

		if ( this.isTouchDevice() ) {

			$( document ).on( 'touchstart', '.icon-up-dir', function() {
				$( this ).toggleClass( 'active' );
				$( this ).closest( 'li' ).find( '> ul' ).slideToggle();
			} );

		} else {

			$( document ).on( 'click', '.icon-up-dir', function() {
				$( this ).toggleClass( 'active' );
				$( this ).closest( 'li' ).find( '> ul' ).slideToggle();
			} );

		}
	},

	/**
	 * Scroll to next section.
	 *
	 * @return {void}
	 */
	bannerArrow: function() {
		const bannerArrow = $( '#banner-arrow' );

		if ( ! bannerArrow.length ) {
			return;
		}

		const target = bannerArrow.parent().parent().next();

		bannerArrow.on( 'click', ( event ) => {

			$( 'html, body' ).animate( {
				scrollTop: ( target.offset().top - 63 )
			}, 600 );

			event.preventDefault();

		} );
	},

	/**
	 * Assign class as per link handler.
	 *
	 * @return {void}
	 */
	lityClasses: function() {
		const imageRegexp        = /(^data:image\/)|(\.(png|jpe?g|gif|svg|webp|bmp|ico|tiff?)(\?\S*)?$)/i;
		const youtubeRegex       = /(youtube(-nocookie)?\.com|youtu\.be)\/(watch\?v=|v\/|u\/|embed\/?)?([\w-]{11})(.*)?/i;
		const vimeoRegex         = /(vimeo(pro)?.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/;
		const googlemapsRegex    = /((maps|www)\.)?google\.([^\/\?]+)\/?((maps\/?)?\?)(.*)/i;
		const facebookvideoRegex = /(facebook\.com)\/([a-z0-9_-]*)\/videos\/([0-9]*)(.*)?$/i;

		$( '[data-lity]' ).each( function() {
			let opener = $( this );
			let target = opener.data( 'lity-target' ) || opener.attr( 'href' ) || opener.attr( 'src' );

			let youTubeVideo  = youtubeRegex.exec( target );
			let vimeoVideo    = vimeoRegex.exec( target );
			let image         = imageRegexp.exec( target );
			let googleMap     = googlemapsRegex.exec( target );
			let facebookVideo = facebookvideoRegex.exec( target );

			if ( youTubeVideo ) {

				opener.addClass( 'icon-youtube-play' );

			} else if ( vimeoVideo ) {

				opener.addClass( 'icon-play' );

			} else if ( image ) {

				opener.addClass( 'image-icon' );

			} else if ( googleMap ) {

				opener.addClass( 'google-map' );

			} else if ( facebookVideo ) {

				opener.addClass( 'facebook-video' );

			}

		} );
	},

	/**
	 * Flip cards.
	 *
	 * @return {void}
	 */
	flipCard: function () {

		const mediaStoryCard = $( '.media-story-card' );
		const windowWidth    = $( window ).width();

		if ( ! mediaStoryCard.length ) {
			return;
		}

		if ( 767 < windowWidth ) {

			mediaStoryCard.each( function () {

				$( this ).on( 'click', function() {

					$( this ).toggleClass( 'is-flipped' );

				} );

			} );
		}

	},

	/**
	 * Thickbox support for gallery.
	 *
	 * @return {void}
	 */
	thickboxGallery: function (  ) {

		if ( $( '.gallery' ).length ) {
			$( '.gallery a' ).fancybox(
				{
					loop: true
				}
			).attr( 'data-fancybox', 'gallery' );
		}

	}

};

export { common };
